import {
  queryAvailability as publicQueryAvailability,
  getScheduleAvailability as publicGetScheduleAvailability,
  calculateMultiSlotAvailability as publicCalculateMultiSlotAvailability,
} from './bookings-availability-v1-slot-availability-availability-calendar.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const queryAvailability: MaybeContext<
  BuildRESTFunction<typeof publicQueryAvailability> &
    typeof publicQueryAvailability
> = /*#__PURE__*/ createRESTModule(publicQueryAvailability);
export const getScheduleAvailability: MaybeContext<
  BuildRESTFunction<typeof publicGetScheduleAvailability> &
    typeof publicGetScheduleAvailability
> = /*#__PURE__*/ createRESTModule(publicGetScheduleAvailability);
export const calculateMultiSlotAvailability: MaybeContext<
  BuildRESTFunction<typeof publicCalculateMultiSlotAvailability> &
    typeof publicCalculateMultiSlotAvailability
> = /*#__PURE__*/ createRESTModule(publicCalculateMultiSlotAvailability);

export {
  LocationType,
  SortOrder,
  LocationLocationType,
} from './bookings-availability-v1-slot-availability-availability-calendar.universal.js';
export {
  SlotAvailability,
  Slot,
  SlotResource,
  Location,
  PhoneCall,
  AvailabilityWaitingList,
  BookingPolicyViolations,
  NestedTimeSlot,
  QueryAvailabilityRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  CursorPaging,
  V2CustomerChoices,
  QueryAvailabilityResponse,
  PagingMetadataV2,
  Cursors,
  GetSlotAvailabilityRequest,
  GetSlotAvailabilityResponse,
  BookingPolicySettings,
  GetScheduleAvailabilityRequest,
  GetScheduleAvailabilityResponse,
  ScheduleAvailability,
  CalculateMultiSlotAvailabilityRequest,
  RuleBasedConstraints,
  ResourcesFilter,
  AvailabilityV2CustomerChoices,
  CalculateMultiSlotAvailabilityResponse,
  CursorPagingMetadata,
  GetAvailabilityTimeSlotRequest,
  TimeSlotLocation,
  CustomerChoices,
  GetAvailabilityTimeSlotResponse,
  TimeSlot,
  EventInfo,
  WaitingList,
  Service_availabilityBookingPolicyViolations,
  AvailableResources,
  Resource,
  Service_availabilityNestedTimeSlot,
  QueryAvailabilityOptions,
  CalculateMultiSlotAvailabilityOptions,
} from './bookings-availability-v1-slot-availability-availability-calendar.universal.js';
export {
  LocationTypeWithLiterals,
  SortOrderWithLiterals,
  LocationLocationTypeWithLiterals,
  GetScheduleAvailabilityApplicationErrors,
} from './bookings-availability-v1-slot-availability-availability-calendar.universal.js';
